import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Footer from "@/components/sections/Footer";

export default function LegalLayout({ eyebrow, title, updated, children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${title} — Modo Motori`;
  }, [title]);

  return (
    <div className="App grain min-h-screen">
      {/* Minimal header for legal pages */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-[#050505]/85 backdrop-blur-xl border-b border-white/[0.06]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-4 lg:py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group min-w-0">
            <span className="relative inline-flex items-center justify-center w-10 h-10 md:w-11 md:h-11 shrink-0 rounded-full overflow-hidden bg-white ring-1 ring-white/10 transition-transform duration-300 group-hover:scale-[1.04]">
              <img
                src="https://customer-assets-agu9un31.emergentagent.net/job_modo-media-kit/artifacts/1ysljo0k_channels4_profile.jpg"
                alt="Modo Motori"
                className="w-full h-full object-cover"
              />
            </span>
            <div className="leading-none min-w-0">
              <div className="font-body font-extrabold text-[16px] md:text-[19px] tracking-[-0.02em] text-white whitespace-nowrap">
                Modo <span className="text-white/95">Motori</span>
              </div>
              <div className="hidden sm:block font-mono text-[9px] tracking-[0.28em] text-white/40 uppercase mt-1 whitespace-nowrap">
                {eyebrow}
              </div>
            </div>
          </Link>
          <Link to="/" className="btn-sharp">
            <ArrowLeft size={14} /> Torna al sito
          </Link>
        </div>
      </header>

      <main className="pt-32 md:pt-40 pb-24 md:pb-32">
        <div className="max-w-[860px] mx-auto px-6 lg:px-10">
          <div className="font-mono text-[11px] tracking-[0.28em] uppercase text-[#FF6B1A] mb-5 flex items-center gap-3">
            <span className="w-6 h-px bg-[#FF6B1A]" />
            {eyebrow}
          </div>
          <h1 className="font-display tighter text-5xl md:text-7xl leading-[0.98] text-white mb-8">
            {title}
          </h1>
          {updated && (
            <div className="font-mono text-[11px] tracking-[0.22em] uppercase text-white/40 mb-14 pb-8 border-b border-white/[0.08]">
              Ultimo aggiornamento — {updated}
            </div>
          )}

          <article className="legal-body space-y-8 text-white/70 text-[16px] leading-[1.75]">
            {children}
          </article>

          <div className="mt-20 pt-10 border-t border-white/[0.08] flex flex-col sm:flex-row gap-4 sm:items-center sm:justify-between">
            <div className="font-mono text-[11px] tracking-[0.18em] uppercase text-white/40 leading-relaxed">
              Delta Pictures S.r.l. — © 2026
              <br />
              Via G. Boglietti 2, 13900 Biella — P.IVA 02154000026
            </div>
            <div className="flex flex-wrap gap-6 font-mono text-[11px] tracking-[0.22em] uppercase text-white/50">
              <Link to="/privacy" className="hover:text-white transition-colors">Privacy</Link>
              <Link to="/cookie" className="hover:text-white transition-colors">Cookie</Link>
              <Link to="/note-legali" className="hover:text-white transition-colors">Note legali</Link>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
